<template>
  <div class="container container-shadow reset-success-container">
    <div class="ico-succes"></div>
    <h2>Congratulations！</h2>
    <p>MYZFX ID {{$route.params.email}} reset password successfully.</p>
    <router-link :to="{name:'login'}" tag="div" class="btn-login">Login</router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {
    window.vuex_store.commit('set_title', 'Account Settings')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';

.reset-success-container {
  height: 364px;
  text-align: center;
  h2 {
    font-size: 30px;
    line-height: 30px;
    color: #333333;
    line-height: 1;
    margin-top: 20px;
  }
  p {
    font-size: 14px;
    line-height: 30px;
    line-height: 1;
    color: #333333;
    margin-top: 15px;
  }
  .ico-succes {
    width: 81px;
    height: 80px;
    margin: 0 auto;
    background: url(~assets/img/ico-success.png) no-repeat;
  }
  .btn-login {
    width: 180px;
    height: 56px;
    margin: 30px auto 0 auto;
    line-height: 56px;
    background-color: #0A95FF;
    font-size: 16px;
    color: #141414;
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
